import { render } from "./Complaints.vue?vue&type=template&id=34ed38e6&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=34ed38e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ed38e6"]])

export default __exports__